import React, { FC } from 'react';
import { Skeleton, Tooltip } from 'src/common';
import styles from './index.module.scss';
import { TenderBlockSize } from 'src/models/procurements/Tender/types';
import { useTenderFree } from 'src/models/procurements/TenderFree/hooks';
import { BlockEmpty, InfoBox, ReadOnlyCurrency } from 'src/shared';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faClock, faCoin } from '@fortawesome/pro-light-svg-icons';
import { useTranslation } from 'react-i18next';
import { useDeadlineDate, usePublishedDate } from 'src/helpers';
import { faUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons';

export const TenderFreeHeader: FC = () => {
  const { t } = useTranslation();
  const { data, loading } = useTenderFree();
  const name = data?.info.name;
  const estValue = data?.info.estValue?.amount && data.info.estValue.currency ? data?.info.estValue : null;
  const published = data?.info.published ?? null;
  const deadline = data?.info.deadline ?? null;
  const publishedDate = usePublishedDate(published);
  const deadlineValue = useDeadlineDate(deadline);

  const buyerName = data?.info.buyerName;
  const buyerLink = data?.info.buyerLink;

  return (
    <div className={styles.header}>
      {loading ? (
        <Skeleton active loading className={styles.loader} />
      ) : data ? (
        <>
          <div className={styles.title}>
            <Tooltip title={name}>
              <h1 className={styles.titleValue}>{name}</h1>
            </Tooltip>
          </div>
          <div className={styles.bar}>
            {buyerName && (
              <Tooltip title={buyerName}>
                {buyerLink ? (
                  <a className={styles.buyerLink} rel="noopener noreferrer" target="_blank" href={buyerLink}>
                    <FontAwesomeIcon icon={faUpRightFromSquare} className={styles.procurerLinkIcon} />
                    <span className={styles.buyerName}>{buyerName}</span>
                  </a>
                ) : (
                  <span className={styles.buyerName}>{buyerName}</span>
                )}
              </Tooltip>
            )}
            <div className={styles.actions}>
              <div className={styles.info}>
                <InfoBox
                  title={t('Tenders.published')}
                  className={styles.infoBox}
                  size={TenderBlockSize.Quarter}
                  value={
                    <div className={styles.content}>
                      <FontAwesomeIcon icon={faClock} className={styles.icon} />
                      <div className={styles.value}>{publishedDate}</div>
                    </div>
                  }
                />
                <InfoBox
                  title={t('Tenders.deadline')}
                  className={styles.infoBox}
                  size={TenderBlockSize.Quarter}
                  value={
                    <div className={styles.content}>
                      <FontAwesomeIcon icon={faBell} className={styles.icon} />
                      <div className={styles.value}>{deadlineValue.value}</div>
                    </div>
                  }
                />
                <InfoBox
                  title={t('Tenders.estValue')}
                  className={styles.infoBox}
                  size={TenderBlockSize.Quarter}
                  value={
                    estValue ? (
                      <ReadOnlyCurrency
                        currency={estValue.currency}
                        amount={estValue.amount}
                        config={{ icon: faCoin, currency: { isShort: true } }}
                      />
                    ) : (
                      <BlockEmpty />
                    )
                  }
                />
              </div>
            </div>
          </div>
        </>
      ) : null}
    </div>
  );
};

export default TenderFreeHeader;
